module.exports = __webpack_public_path__ + "static/media/lefttg.b2f985bd.png";